
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(badge, badgeIndex) {
                    return _createElement('div', {
                        'className': 'product-label-wrapper flex',
                        'key': badge
                    }, _createElement('span', { 'className': 'product-label product-label--custom cm_badge cm_badge__' + this.toKebabCase(badge) }, '\n            ', badge, '\n          '));
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatI3(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                function scopeProduct4() {
                    var product = this.productData ?? this;
                    return [product.is_autosync_allowed ? _createElement('button', {
                            'className': 'cm_view-on-vehicle-btn btn btn--secondary',
                            'onClick': () => window.Convermax.openAutoSyncDialog(product.autosync_id, product.autosync_mpn, product.FitmentType?.includes('Tire')),
                            'type': 'button',
                            'key': '52131'
                        }, '\n    ', _translate(`view_product_on_vehicle`), '\n  ') : null];
                }
                return _createElement('li', {}, _createElement('product-card', { 'class': 'card card--product h-full card--product-compare relative flex' + (this.is_promotional_item ? ' cm_promotion' : '') }, _createElement('div', { 'className': 'card__media relative' }, _createElement('a', {
                    'href': this.url,
                    'aria-label': this.removeHTML(this.title),
                    'className': 'media block relative image-blend js-prod-link',
                    'tabIndex': '-1'
                }, _createElement('img', {
                    'className': 'img-fit card__main-image no-js-hidden',
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'data-media-id': this.id,
                    'loading': 'lazy',
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                })), _createElement.apply(this, [
                    'div',
                    { 'className': 'product-label-container absolute top-0 start' },
                    this.out_of_stock ? _createElement('div', {
                        'className': 'product-label-wrapper flex',
                        'key': '649'
                    }, _createElement('span', { 'className': 'product-label product-label--sold-out' }, _translate(`product_out_of_stock`))) : null,
                    this.on_sale ? _createElement('div', {
                        'className': 'product-label-wrapper flex',
                        'key': '846'
                    }, _createElement('span', { 'className': 'product-label product-label--sale' }, 'Sale')) : null,
                    this._badges ? _map(this._badges, repeatBadge1.bind(this)) : null
                ])), _createElement('div', { 'className': 'card__info-container flex flex-col flex-auto relative' }, _createElement('div', { 'className': 'card__info w-full' }, _createElement('div', { 'className': 'card__info-inner inline-block w-full' }, this.vendor ? _createElement('p', mergeProps({
                    'className': 'card__vendor mb-1 text-sm text-theme-light',
                    'key': '1473'
                }, { dangerouslySetInnerHTML: { __html: typeof this.vendor === 'undefined' ? '' : this.vendor } })) : null, _createElement('p', { 'className': 'card__title font-bold mb-1' }, _createElement('a', mergeProps({
                    'href': this.url,
                    'className': 'card-link text-current js-prod-link'
                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } }))), [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '19540'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI3.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null], _createElement('div', { 'className': 'price' }, _createElement('div', { 'className': 'price__default' }, this.price_varies ? _createElement('span', { 'key': '2436' }, _translate(`price_from`), ' ') : null, _createElement('strong', { 'className': 'price__current' }, this.formatPrice(this.min_price || this.price)), this.on_sale ? _createElement('s', {
                    'className': 'price__was',
                    'key': '2621'
                }, this.formatPrice(this.compare_at_price)) : null, this.set_qty && !this.price_varies ? _createElement('div', {
                    'className': 'price-item--set',
                    'key': '2724'
                }, '\n                ', _translate(`product_set_of`, {  count: this.set_qty  }), ': ', this.formatPrice(this.price * this.set_qty), '\n              ') : null)))), _createElement('div', { 'className': 'card__quick-add mob:card__quick-add--below desktop:card__quick-add--below' }, _createElement('product-form', {}, _createElement('div', {
                    'className': 'alert mb-8 bg-error-bg text-error-text js-form-error text-start',
                    'role': 'alert',
                    'hidden': true
                }), _createElement('form', {
                    'method': 'post',
                    'action': '/cart/add',
                    'id': 'quick-add-' + this.id,
                    'acceptCharset': 'UTF-8',
                    'className': 'js-product-form',
                    'encType': 'multipart/form-data',
                    'noValidate': 'novalidate'
                }, _createElement('input', {
                    'type': 'hidden',
                    'name': 'form_type',
                    'value': 'product'
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'utf8',
                    'value': '\u2713'
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'product-id',
                    'value': this.id
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'id',
                    'value': this.variant_ids[0]
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'quantity',
                    'value': this.set_qty || 1
                }), this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                    'type': 'hidden',
                    'name': 'properties[Fitment]',
                    'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                    'key': '3783'
                }) : null, this.out_of_stock || !this.out_of_stock && this.variant_ids.length === 1 && (!this.ProductScope || this.ProductScope === 'child') ? _createElement('button', {
                    'className': 'btn btn--primary w-full',
                    'data-add-to-cart-text': 'Add to cart',
                    'name': 'add',
                    'aria-haspopup': 'dialog',
                    'disabled': this.out_of_stock,
                    'key': '3995'
                }, _createElement('span', { 'className': 'quick-add-btn-text' }, this.out_of_stock ? [_translate(`product_out_of_stock`)] : null, !this.out_of_stock ? [
                    _translate(`product_add_to_cart`),
                    this.set_qty ? ` ${ _translate(`product_set_of`, {  count: this.set_qty  }) }` : ''
                ] : null)) : null)), !this.out_of_stock && this.variant_ids.length > 1 || this.ProductScope === 'master' ? _createElement('button', {
                    'type': 'button',
                    'className': 'btn btn--primary w-full js-quick-add',
                    'aria-haspopup': 'dialog',
                    'data-product-url': this.url,
                    'data-product-default-variant': 'false',
                    'data-quick-add-listener-added': 'true',
                    'key': '4751'
                }, _createElement('span', { 'className': 'quick-add-btn-text block pointer-events-none' }, _translate(`product_select_options`))) : null, [scopeProduct4.apply(this, [])])), this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '5648'
                }) : null));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'h4 mt-10 cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'ul',
        { 'className': 'slider slider__grid grid grid-flow-col auto-cols-2 small-cards-mobile md:auto-cols-3 lg:auto-cols-4 xl:auto-cols-5 small-cards-desktop gap-x-theme gap-y-8 cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []